import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateProduct } from "../../features/product";
import { useGetCategory } from "../../features/category";
import { formatNumber, unformatNumber } from "../../utils/HelperFormatNumber";

const ProductCreate = () => {
  const { create } = useCreateProduct();
  const { category } = useGetCategory();

  useEffect(() => {
    if (category && category.length > 0 && !formData.productCategoryId) {
      setFormData((prev) => ({
        ...prev,
        productCategoryId: category[0].id,
      }));
    }
  }, [category]);

  const [formData, setFormData] = useState({
    name: "",
    price: 0,
    description: "",
    code: "",
    category: "COMMON",
    paymentType: "DIRECT",
    productCategoryId: "",
  });

  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    create(formData);
    console.log("Product Data Submitted:", formData);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <div className="flex-1 p-8">
        <h1 className="text-xl font-bold text-center mb-8">Create Product</h1>
        <form
          onSubmit={handleSubmit}
          className="max-w-2xl mx-auto bg-white p-6 shadow-md rounded-md"
        >
          <div className="mb-4">
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              Nama
            </label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="code"
              className="block text-sm font-medium text-gray-700"
            >
              Code
            </label>
            <input
              type="text"
              id="code"
              placeholder="Code"
              name="code"
              value={formData.code}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="paymentType"
              className="block text-sm font-medium text-gray-700"
            >
              Payment Type
            </label>
            <select
              id="paymentType"
              name="paymentType"
              value={formData.paymentType}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            >
              <option value="DIRECT">DIRECT</option>
              <option value="INDIRECT">INDIRECT</option>
            </select>
          </div>
          <div className="mb-4">
            <label
              htmlFor="productCategoryId"
              className="block text-sm font-medium text-gray-700"
            >
              Category
            </label>
            <select
              id="productCategoryId"
              name="productCategoryId"
              value={formData.productCategoryId}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            >
              {category &&
                category.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="mb-4">
            <label
              htmlFor="category"
              className="block text-sm font-medium text-gray-700"
            >
              Operator
            </label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            >
              <option value="COMMON">COMMON</option>
              <option value="HIFI">HIFI</option>
              <option value="OTHERS">OTHERS</option>
            </select>
          </div>

          <div className="mb-4">
            <label
              htmlFor="price"
              className="block text-sm font-medium text-gray-700"
            >
              Harga
            </label>
            <input
              type="text"
              id="price"
              name="price"
              value={formatNumber(formData.price.toString())}
              onChange={(e) => {
                const rawValue = unformatNumber(e.target.value);
                if (/^\d*$/.test(rawValue)) {
                  setFormData({ ...formData, price: Number(rawValue) });
                }
              }}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="Masukkan harga, contoh: 10,000"
              required
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="description"
              className="block text-sm font-medium text-gray-700"
            >
              Description
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              rows={4}
              placeholder="Description"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full mt-6 py-2 px-4 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            Submit
          </button>
          <button
            type="button"
            onClick={() => navigate("/product")}
            className="w-full mt-6 py-2 px-4  bg-gray-400 text-white font-medium rounded-mdfocus:outline-none focus:ring-2 "
          >
            Back
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProductCreate;
